import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {deleteOrder, getCurrentOrder, resetSentInvoicOrderStatus, sendInvoice} from "../../store/reducers/OrdersSlice";

interface InvoiceOrderScreenProps {
}

export const InvoiceOrderScreen: React.FC<InvoiceOrderScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const ordersState = useAppSelector((state) => state.orders);
    const requestStatus: RequestStatus = ordersState.sendInvoiceStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Veod", url: "/orders"},
        {text: "Arve väljastamine", url: `/orders/${id}/invoice`},
    ];

    useEffect(() => {
        dispatch(resetSentInvoicOrderStatus());
    }, [location]);

    const handleConfirm = () => {
        if (id) {
            dispatch(sendInvoice({id}));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (id) {
            dispatch(getCurrentOrder({id}));
        }
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Arve saadetud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid antud rea kohta arve väljastada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};